
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { Toaster } from 'react-hot-toast';
// import ProtectedRoute from './components/ProtectedRoute';
// import PublicRoute from './components/PublicRoute';
import MatrimonialRegistrationPage from './pages/MatrimonialRegistrationPage';
import LoginPage from './pages/LoginPage';
       

function App() {
  return (
   <Router>
      {/* <Toaster position="top-right" /> */}

      <Routes>
        {/* Admin Layout and Dashboard */}
        {/* <Route element={<ProtectedRoute />}> */}
          {/* <Route path="/admin-Dashboard" element={<Dashboard />} /> */}
          {/* <Route path="/exercise" element={<Exercise />} /> */}

          {/* <Route path="/admin-comany-create" element={<CompanyRegistration />} /> */}

        {/* </Route> */}

        {/* Public Customer Routes */}
        <Route
          path="/*"
          element={
            <>
              {/* <CustomerHeader /> */}
              <Routes>
               
                <Route path="/login" element={<LoginPage />} />
                <Route path="/Matrimonial-register" element={<MatrimonialRegistrationPage />} />
                

                {/* <Route path="/login" element={<PublicRoute />}> */}
                  {/* <Route index element={<Login />} /> */}
                {/* </Route> */}
                {/* <Route path="*" element={<PageNotFound />} /> */}
              </Routes>
              
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
